"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  hoaType: 'HOA Green Fied',
  addressType: 'New York, 147 Green Fied'
};